// 路由文件
import Vue from 'vue'
import Router from 'vue-router'


// import Login from '../page/login/login'//登录
import Login from '../page/index/login'//登录
import Apply from '../page/apply/apply'//首页
import ApplyTicket from '../page/apply/applyTicket'//申请发票
import TicketDetail from '../page/apply/ticketDetail'//发票详情
import ClassList from '../page/apply/classList'//班次列表
import WorkType from '../page/apply/workType'//班次列表
import ApplyForm from '../page/apply/applyForm'//填写报名表单
import QueryScore from '../page/apply/queryScore'//查询成绩
import UserInfo from '../page/apply/userInfo'//个人资料
import CompanyInfo from '../page/apply/companyInfo'//企业资料
import myMessage from '../page/apply/myMessage'//我的消息
import CompanyList from '../page/apply/companyList'//企业绑定(未绑定)
import uCompanyList from '../page/apply/uCompanyList'//企业绑定(已绑定)
import StudentList from '../page/apply/studentList'//绑定的学员
import City from '../page/apply/City'//绑定的学员
import UpdatePwd from '../page/apply/updatePwd'//修改密码(个人)
import ForgotPwd from '../page/apply/forgotPwd'//修改密码(个人)
import UpdatePhone from '../page/apply/updatePhone'//修改手机号(个人)
import UpdateCompanyPwd from '../page/apply/updateCompanyPwd'//修改密码(企业)
import DownApplyData from '../page/apply/downApplyData'//下载报名资料
import UploadingApplyData from '../page/apply/uploadingApplyData'//上传报名资料
import ChooseUserOrCompany from '../page/register/userOrCompany'//学员注册获取公司注册
import SubmitSuccess from '../page/register/submitSuccess'//提交成功
import PaySuccess from '../page/apply/paySuccess'//提交成功
import StudentRegister from '../page/register/student/studentRegister'//学员填写第一步信息
import WriteUserInfo from '../page/register/student/writeUserInfo'//学员填写第二步填写信息
import CompanyRegister from '../page/register/company/companyRegister'//企业注册
Vue.use(Router)

export default new Router({
    routes:[
        //配置路由路径及其跳转的组件
        {
            path:'/Login',name:'login',meta:{title:""},component:Login,//需要加校检判断的路由}
        },
        // {
        //     path:'/login',name:'login',meta:{title:"东莞建设培训中心"},component:Login
        // },
        {   path:'/',name:'index',meta:{title:"培训报名",needLogin:true},component:Apply,
        },
        {   path:'/applyTicket',name:'applyTicket',meta:{title:"申请发票"},component:ApplyTicket,
        },
        {   path:'/ticketDetail',name:'ticketDetail',meta:{title:"发票详情"},component:TicketDetail,
        },
        {
            path:'/classList',name:'classList',meta:{title:"班次列表"},component:ClassList,
        },
        {
            path:'/workType',name:'workType',meta:{title:"选择工种"},component:WorkType,
        },
        {
            path:'/applyForm',name:'applyForm',meta:{title:"选择工种"},component:ApplyForm,
        },
        {
            path:'/queryScore',name:'queryScore',meta:{title:"成绩查询"},component:QueryScore
        },
        {
            path:'/userInfo',name:'userInfo',meta:{title:"个人资料"},component:UserInfo
        },
        {
            path:'/myMessage',name:'myMessage',meta:{title:"我的消息"},component:myMessage
        },
        {   //未绑定
            path:'/company',name:'company',meta:{title:"企业绑定"},component:CompanyList
        },
        {   //已绑定
            path:'/uCompanyList',name:'uCompanyList',meta:{title:"企业绑定"},component:uCompanyList
        },
        {   //已绑定
            path:'/studentList',name:'studentList',meta:{title:"绑定的学员"},component:StudentList
        },
        {   //已绑定
            path:'/city',name:'city',meta:{title:"绑定的学员"},component:City
        },
        {   //个人修改密码
            path:'/updatePwd',name:'updatePwd',meta:{title:"修改密码",needLogin:true},component:UpdatePwd
        },
        {   //个人修改密码
            path:'/updatePhone',name:'updatePhone',meta:{title:"更改绑定手机",needLogin:true},component:UpdatePhone
        },
        {   //企业修改密码
            path:'/updateCompanyPwd',name:'updateCompanyPwd',meta:{title:"修改密码"},component:UpdateCompanyPwd
        },
        {   //忘记密码
            path:'/forgotPwd',name:'forgotPwd',meta:{title:"忘记密码"},component:ForgotPwd
        },
        {
            path:'/companyInfo',name:'companyInfo',meta:{title:"企业资料"},component:CompanyInfo
        },
        {
            path:'/companyList',name:'companyList',meta:{title:"我的消息"},component:CompanyList
        },
        {
            path:'/downApplyData',name:'downApplyData',meta:{title:"下载报名资料"},component:DownApplyData
        },
        {
            path:'/uploadingApplyData',name:'uploadingApplyData',meta:{title:"上传报名资料"},component:UploadingApplyData
        },
        {
            path:'/chooseUserOrCompany',name:'chooseUserOrCompany',meta:{title:"注册"},component:ChooseUserOrCompany,isBack: false
        },
        {
            path:'/studentRegister',name:'studentRegister',meta:{title:"注册学员"},component:StudentRegister
        },
        {
            path:'/writeUserInfo',name:'writeUserInfo',meta:{title:"填写个人资料"},component:WriteUserInfo
        },
        {
            path:'/companyRegister',name:'companyRegister',meta:{title:"注册企业账号"},component:CompanyRegister
        },
        {
            path:'/submitSuccess',name:'submitSuccess',meta:{title:"提交成功"},component:SubmitSuccess
        },
        {
            path:'/paySuccess',name:'paySuccess',meta:{title:"支付成功"},component:PaySuccess
        },
    ],
    mode:'hash' //去掉路径中的"#"
})